import React, { Component } from 'react';
import classNames from 'classnames';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb, DropdownButton, MenuItem, ButtonGroup } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { DatePicker } from '../Common/datePicker';
import { DisabledInputField } from '../Common/inputField';
import PriceFormatter from '../Common/priceFormatter';
import CashFormatter from '../Common/cashFormatter';
import { numberWithCommas } from '../Common/numberWithCommas';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isLAP, isAPD, isVAK, isGGI, isLMH, isCT } from '../../actions/root_url';
import checkPermission from '../Common/permissions';
import {getFromToDates} from '../Common/cleanDates'
import EmailContentModal from '../Sales/components/EmailContentModal';
import { getLocalStorageData } from '../../reducers/headerRedux'
import axios from "axios";
import _ from 'lodash';

momentLocalizer(moment);

const getBsStyle = (input, value) => {
  return input === value ? 'success':'primary'
};

class RowRenderer extends Component {


    render() {
        //here we are just changing the style
        //but we could replace this with anything we liked, cards, images, etc
        //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
        return (<div onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }} ><ReactDataGrid.Row ref='row' {...this.props} /></div>);
    }
}

RowRenderer.PropTypes = {
  onDoubleClick: React.PropTypes.func
};

const renderCustomerTypeRadios = props => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.error }, 'col-xs-4');
  return (
    <ButtonToolbar className='long-radio-filter-buttons'>
      <Button bsStyle={getBsStyle(props.input.value, 'all')}>
        <div className='radio'>
          <label for='all-radio-filter'>
            <input {...props.input} id='all-radio-filter' type='radio' name='statusFilterRadios' value='all' checked={props.input.value === 'all'}/>
            <Translate value="all" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Active')}>
        <div className='radio'>
          <label for='active-radio-filter'>
            <input {...props.input} id='active-radio-filter' type='radio' name='statusFilterRadios' value='Active' checked={props.input.value === 'Active'}/>
            <Translate value="active" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Inactive')}>
        <div className='radio'>
          <label for='inactive-radio-filter'>
            <input {...props.input} id='inactive-radio-filter' type='radio' name='statusFilterRadios' value='Inactive' checked={props.input.value === 'Inactive'}/>
            <Translate value="inactive" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  )
}


class CustomerStatementMain extends Component {
  static contextTypes = {
      router: React.PropTypes.object
  };
  constructor() {
    super();
    this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.customersPage,
        rows: [],
        filters: {},
        selectedRows: [],
        selectedIds: [],
        sortColumn: null,
        sortDirection: null,
        PdfFrameLoaded: true,
        amount00_07: 0,
        amount08_30: 0,
        amount00_30: 0,
        amount31_60: 0,
        amount61_90: 0,
        amount_91: 0,
        current: 0,
        grand_amount: 0,
        Days: '',
        emailContentModalVisibility: false,
        emailSubjectTemplate: '',
        emailContentTemplate: '',
        selectedOptions: ['30']
    };
    this.handleResize = this.handleResize.bind(this);
    this.fetchCustomerStatementList = this.fetchCustomerStatementList.bind(this);
    this.statementDetail = this.statementDetail.bind(this);
  }

  componentWillMount() {
    const activeCompany = getLocalStorageData('selectedCompany')
    this.props.setDefaultOfForm('typeRadios', 'Active', 'customerStatementMain');
    this.props.setDefaultOfForm('Days', new Date(), 'customerStatementMain');
    if (!(isLAP || isAPD)) {
      if ((isGGI || isLMH) && activeCompany) {
        this.props.fetchCustomerStatementList('Active', moment().format('YYYY-MM-DD'), '', activeCompany.value);
      } else {
        this.props.fetchCustomerStatementList('Active', moment().format('YYYY-MM-DD'));
      }
    }
    if ((isLAP || isAPD)) {
      this.props.setDefaultOfForm('agedDaysRadios', '30', 'customerStatementMain');
      this.props.fetchCustomerStatementList('Active', moment().format('YYYY-MM-DD'), '30');
    }
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.typeRadios) {
      this.props.setDefaultOfForm('typeRadios', 'Active', 'customerStatementMain');
    }
    if ((isLAP || isAPD) && !nextProps.agedDaysRadios) {
      this.props.setDefaultOfForm('agedDaysRadios', '30', 'customerStatementMain');
    }

    if (!nextProps.Days) {
      this.props.setDefaultOfForm('Days', new Date(), 'customerStatementMain');
    }
    if (nextProps.customerStatementList && !_.isEqual(nextProps.customerStatementList, this.props.customerStatementList)) {
      const {
        statement_lines,
        amount00_07,
        amount08_30,
        amount00_30,
        amount31_60,
        amount61_90,
        amount_91,
        current,
        grand_amount,
      } = nextProps.customerStatementList;
      this.setState({
        rows: statement_lines,
        amount00_07: parseFloat(amount00_07).toFixed(2) || 0,
        amount08_30: parseFloat(amount08_30).toFixed(2) || 0,
        amount00_30: parseFloat(amount00_30).toFixed(2) || 0,
        amount31_60: parseFloat(amount31_60).toFixed(2) || 0,
        amount61_90: parseFloat(amount61_90).toFixed(2) || 0,
        amount_91: parseFloat(amount_91).toFixed(2) || 0,
        current: parseFloat(current).toFixed(2) || 0,
        grand_amount: parseFloat(grand_amount).toFixed(2) || 0,
      });
    }

    if (nextProps.typeRadios && nextProps.typeRadios !== this.props.typeRadios) {
      const activeCompany = getLocalStorageData('selectedCompany')
      if (this.props.Days){
        let days = moment(this.props.Days).format('YYYY-MM-DD');
        if ((isLAP || isAPD)) {
          this.props.fetchCustomerStatementList(nextProps.typeRadios, days, this.state.selectedOptions.join(','))
        } else {
          if (isGGI || isLMH) {
            this.props.fetchCustomerStatementList(nextProps.typeRadios, days, '', activeCompany.value)
          } else {
            this.props.fetchCustomerStatementList(nextProps.typeRadios, days)
          }
        }
      }
    }
    if (nextProps.agedDaysRadios && nextProps.agedDaysRadios !== this.props.agedDaysRadios) {
      if ((isLAP || isAPD) && nextProps.Days){
        let days = moment(this.props.Days).format('YYYY-MM-DD');
        this.props.fetchCustomerStatementList(nextProps.typeRadios, days, this.state.selectedOptions.join(','))
      }
    }
    if (nextProps.Days && nextProps.Days !== this.props.Days) {
      const { Days } = nextProps;
      this.setState({ Days }, this.fetchCustomerStatementList);
    }

    if (nextProps.arReport && nextProps.arReport !== this.props.arReport) {
      this.setState({ PdfFrameLoaded: false });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded === false) {
      return false;
    }

    return true;
  }
  handleResize(e) {
      this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.customersPage });
  }

  genSubjectTemplate = () => {
      const activeCompany = getLocalStorageData('selectedCompany').label;
      return `Customer Statement from ${activeCompany.toUpperCase()}`
  }

  genContentTemplate = () => {
      const activeCompany = getLocalStorageData('selectedCompany').label;
      return `Dear Customer,

      Your Statement is attached. Please review the details.
      Thank you for your business - we appreciate it very much.

      Sincerely,
      ${activeCompany.toUpperCase()}.`
  }

  handleSendExcel() {
    this.setState({
      emailSubjectTemplate: this.genSubjectTemplate(),
      emailContentTemplate: this.genContentTemplate(),
      emailContentModalVisibility: true,
    })
  }

  handleEmailContentConfirm(subject, content, sendEmail, ids) {
    if(!sendEmail) {
      alert('Email cannot be empty!')
      return
    }
    const { typeRadios } = this.props;
    let { Days: date } = this.props;
    date = moment(date).endOf('day').toISOString();
    date = `PostingDate=${date}`;
    const token = localStorage.getItem('token');
    let exportUrl = `${ROOT_URL}v1/ar/report/aged/${typeRadios || 'Active'}/excel/?${date}&Bearer=${token}&customer_ids=${ids.toString()}&is_send_email=1&subject=${subject}&content=${content}&send_to=${sendEmail}`;
    axios.get(
      exportUrl,
    )
    .then((response) => {
      alert('Send Successful');
    });
    this.handleEmailContentClose();
  }

  handleEmailContentClose = () => {
    this.setState({
      emailContentModalVisibility: false,
      emailSubjectModalTemplate: '',
      emailContentModalTemplate: ''
    })
  }

  formatDate(date) {
    let formattedDate = date.getFullYear() + '-';

    formattedDate += date.getMonth()+1 + '-';
    if (date.getDate() < 10) {
      formattedDate += '0' + date.getDate();
    } else {
      formattedDate += date.getDate();
    }

    return formattedDate;
  }

  statementDetail() {

    const currentCustomer = arguments[0];
    this.props.resetCurrentCustomer();
    this.props.selectCustomer(currentCustomer);
    this.context.router.push('/customerStatement');

  }
    // this.context.router.push('/products/'+currentInventory.Product_id);

    handleButtonClick = (option) => {
      const { selectedOptions } = this.state
      let selectedOptionsData = [...selectedOptions]
      if (selectedOptionsData.includes(option)) {
        selectedOptionsData = selectedOptionsData.filter((opt) => opt !== option)
        this.setState({
          selectedOptions: selectedOptionsData
        }, () => {
          if (this.props.Days) {
            let days = moment(this.props.Days).format('YYYY-MM-DD');
            this.props.fetchCustomerStatementList(this.props.typeRadios, days, selectedOptionsData.filter(item => item !== 'daysAll').join(','))
          }
        })
      } else {
        if (option ==='daysAll') {
          selectedOptionsData = ['daysAll']
        } else {
          selectedOptionsData = selectedOptionsData.filter((item) => item !== 'daysAll')
          selectedOptionsData.push(option)
        }
        this.setState({
          selectedOptions: selectedOptionsData
        }, () => {
          if (this.props.Days) {
            let days = moment(this.props.Days).format('YYYY-MM-DD');
            this.props.fetchCustomerStatementList(this.props.typeRadios, days, selectedOptionsData.filter(item => item !== 'daysAll').join(','))
          }
        })
      }
    };
  fetchCustomerStatementList() {
    if (this.state.Days){
      let days = moment(this.state.Days).format('YYYY-MM-DD');
      if ((isLAP || isAPD)) {
        this.props.fetchCustomerStatementList(this.props.typeRadios, days, this.state.selectedOptions.join(','));
      } else {
        if (isGGI || isLMH) {
          const activeCompany = getLocalStorageData('selectedCompany')
          this.props.fetchCustomerStatementList(this.props.typeRadios, days, '', activeCompany.value);
        } else {
          this.props.fetchCustomerStatementList(this.props.typeRadios, days);
        }
      }
      }
    }

  renderTable() {
    if (this.props.customerStatementListIsLoading && !this.props.customerStatementListError) {
      return (
        <div id="spinner">
          <Spinner/>
        </div>
      );
    } else if (this.props.customerStatementListError) {
      return (
        <div className="alert alert-danger">
          <Translate value="something_unexpected_happened" />
        </div>
      );
    } else {
        // Parameters of the react-data-grid

        let tableHeight = (window.innerHeight < 930) ? 510 : 510;

        const getRows = () => {
            return Data.Selectors.getRows(this.state);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }


        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
          this.setState(prevState => ({
            ...prevState,
            sortColumn,
            sortDirection,
          }));
        }

        const onClearFilters = () => {
          let rows = [...this.state.rows]
          this.setState({ rows, filters: {}, selectedRows:[], selectedIds:[]});
        };


      const onRowsSelected = (rows) => {
        let cpRows = [...getRows()]
        let selectedRows = [...this.state.selectedRows];
        let selectedIds = [...this.state.selectedIds];
        let selRows = cpRows.map(item => {
          let isHave = false;
          rows.map(row => {
            if(item.Deliver_Customer_id == row.row.Deliver_Customer_id) {
              isHave = true;
            }
          })
          if(isHave) {
            selectedRows.push({...item, isSelected: true});
            selectedIds.push(item.Deliver_Customer_id);
            return {...item, isSelected: true}
          } else {
            return item;
          }
        })
        this.setState({ rows: selRows, selectedRows, selectedIds});
      };
      const onRowsDeselected = (rows) => {
        let cpRows = [...this.state.rows];
        rows.map(item => {
          cpRows[item.rowIdx].isSelected = false;
        })

        let selectedRows = [];
        let selectedIds = [];
        cpRows.map(item => {
          if(item.isSelected) {
            selectedRows.push(item);
            selectedIds.push(item.Deliver_Customer_id)
          }
        })
        this.setState({ rows: cpRows, selectedRows, selectedIds });
      };

        const handleFilterChange = filter => {
          let newFilters = Object.assign({}, this.state.filters);
          if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
          } else {
            delete newFilters[filter.column.key];
          }
          this.setState({ filters: newFilters });
        }

        //Custom Formatter component

        const DateFormatter = React.createClass({
            render() {
                if (this.props.value) {
                  let dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                  let date = new Date(this.props.value)
                  let index = dateMap.indexOf(date.toString().slice(4,3));
                  let localDate = index + date.toString().slice(8, 6);
                  return <span>{date.toString().slice(4, 15)}</span>;;
                }
                else return <span className='label label-danger'>-</span>;
            }
        });

        // Column difinition
        const {selectedOptions} = this.state;
        const columns = [
          {
              key: 'CustomerNum',
              name: <Translate value="customer_num" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 120,
          },
          {
              key: 'Name',
              name: <Translate value="customer_name" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 200,
          },
          {
              key: 'Description',
              name: <Translate value="description" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 100,
          },
          /* { // Commented 11/17/17 branch: feature/ARAP
              key: 'current',
              name: <Translate value="current" />,
              resizable: true,
              sortable: true,
              width: 80,
              formatter: PriceFormatter,
          }, */
          ...((isLAP || isAPD) && (selectedOptions.includes('daysAll') || selectedOptions.includes('30')) || !(isLAP || isAPD)) ? [
          {
              key: 'amount00_30',
              name: <Translate value="00_dashsign_30_days" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 80,
              formatter: CashFormatter,
          }] : [],
          ...((isLAP || isAPD) && (selectedOptions.includes('daysAll') || selectedOptions.includes('60')) || !(isLAP || isAPD)) ? [
          {
              key: 'amount31_60',
              name: <Translate value="31_dashsign_60_days" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 80,
              formatter: CashFormatter,
          }] : [],
          ...((isLAP || isAPD) && (selectedOptions.includes('daysAll') || selectedOptions.includes('90')) || !(isLAP || isAPD)) ? [
          {
              key: 'amount61_90',
              name: <Translate value="61_dashsign_90_days" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 80,
              formatter: CashFormatter,
          }] : [],
          ...((isLAP || isAPD) && (selectedOptions.includes('daysAll') || selectedOptions.includes('91')) || !(isLAP || isAPD)) ? [
          {
              key: 'amount_91',
              name: <Translate value="91_plussign_days" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 80,
              formatter: CashFormatter,
          }] : [],
          {
              key: 'total_amount',
              name: <Translate value="total_amount" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 100,
              formatter: CashFormatter,
          },
          {
              key: 'Sales_User_Name',
              name: <Translate value="sales" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 100,
          },
        ]
        let children = {};

        if ((isLAP || isAPD)) {
          const total_amountIndex = _.findIndex(columns, { key: 'total_amount' });
          const overDue = {
            key: 'Overdue',
            name: <Translate value="past_due" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 100,
            formatter: ({ value }) => (
              <div style={{ width: "100%", height: "100%" }}>
                {value ? "$" + value.toFixed(2) : null}
              </div>
            ),
          }
          const paymentTerm = {
            key: 'PaymentTerm',
            name: <Translate value="payment_term" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 100,
          };
          columns.splice(total_amountIndex, 0, overDue, paymentTerm);
          children = {
            rowSelection:{
              showCheckbox: true,
              onRowsSelected,
              onRowsDeselected,
              selectBy: {
                isSelectedKey: 'isSelected',
              },
            },
            toolbar:<Toolbar enableFilter />,
            onAddFilter:handleFilterChange,
            onClearFilters:onClearFilters,
          }
        }

        if (isVAK) {
          children = {
            toolbar:<Toolbar enableFilter />,
            onAddFilter:handleFilterChange,
            onClearFilters:onClearFilters,
          }
        }

        if (isCT) {
          const indexEstDelivery = _.findIndex(columns, { key: 'amount00_30' });
          const estColum1 = {
            key: 'amount00_07',
            name: <Translate value="00_dashsign_07_days" />,
            resizable: true,
            sortable: true,
            width: 80,
            formatter: CashFormatter,
          };
          const estColum2 = {
            key: 'amount08_30',
            name: <Translate value="08_dashsign_30_days" />,
            resizable: true,
            sortable: true,
            width: 80,
            formatter: CashFormatter,
          };
          columns.splice(indexEstDelivery, 1, estColum1);
          columns.splice(indexEstDelivery+1, 0, estColum2);
        }

        //React Table Purchase Order Full Table
        return (
          <Row>
            <Col sm={ 12 }>
              <div className='react-table-ar-ap-customer-list-statement' id="CustomerStatementMain-dataGrid1">
                <ReactDataGrid
                    {...children}
                    rowRenderer={<RowRenderer onDoubleClick={this.statementDetail} />}
                    rowKey='Deliver_Customer_id'
                    enableCellSelect={true}
                    onGridSort={handleGridSort}
                    columns={columns}
                    rowHeight={25}
                    headerRowHeight={45}
                    rowGetter={rowGetter}
                    rowsCount={getSize() }
                    minHeight={tableHeight}

                    // toolbar={<Toolbar enableFilter />}
                    // onAddFilter={handleFilterChange}

                  />
              </div>
            </Col>
          </Row>
        )
    }
  }
  IFrameIsLoaded = () => {
    if (!this.state.PdfFrameLoaded) {
      const pdfFrame = window.frames.Pdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PdfFrameLoaded: true });
    }
  }

  renderIFrame() {
    if (this.props.arReport) {
      const file = window.URL.createObjectURL(this.props.arReport);
      return (
          <iframe style={{ display: 'none' }} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
      );
    }
  }

  renderPrintStatements() {
    if(!(isLAP || isAPD)) {
      return null
    }
    const {selectedOptions, sortDirection, sortColumn} = this.state;
    let selectedOptionsParams = selectedOptions.filter(item => item !== 'daysAll').join(',')
    let otherParams = sortDirection !== null ?
    {order_by: sortDirection == 'ASC' ? sortColumn !== null : `-${sortColumn}`} : {};

    return (
      <Button
      bsStyle='success'
      type='button'
      disabled={this.state.rows && this.state.rows.length == 0 || !checkPermission('print_customer_statement')}
      onClick={() => {
        if (this.state.Days) {
          let ids = [...this.state.selectedIds];
          let days = moment(this.state.Days).format('YYYY-MM-DD');
          if(ids.length == 0) {
            this.props.printARAgedReport(this.props.typeRadios, days, [], selectedOptionsParams, otherParams);
          } else {
            this.props.printARAgedReport(this.props.typeRadios, days, ids, selectedOptionsParams, otherParams);
          }
        } else {
          alert('date is null')
        }
      }}
  >
    <em className='fa fa-print' />
    <Translate value="print_statements" />
  </Button>
    )
  }

  renderSendExceltButton() {
    if(!(isLAP || isAPD)) return
    return (
      <Button
        bsStyle='success'
        type='button'
        onClick={()=>{this.handleSendExcel()}}
        disabled={this.state.selectedRows.length !=1}
      >
        <Translate value="email_detail_excel" />
      </Button>
    );
  }

  renderSimplifiedExportButton() {
    const { typeRadios } = this.props;
    let { Days: date, selectedCompany } = this.props;
    const {selectedOptions} = this.state;
    let selectedOptionsParams = selectedOptions.filter(item => item !== 'daysAll').join(',')
    let agedDaysParams = `&aged_days=${selectedOptionsParams || ''}`
    date = moment(date).endOf('day').toISOString();
    date = `PostingDate=${date}`;
    const token = localStorage.getItem('token');
    selectedCompany = `&company_id=${selectedCompany.value}`
    let url = `${ROOT_URL}v1/ar/statement/excel/${typeRadios || 'Active'}/?${date}&Bearer=${token}`;
    let ids = [...this.state.selectedIds];
    if((isLAP || isAPD) && ids.length > 0) {
      url = url + `&customer_ids=${ids}`
    }
    if ((isLAP || isAPD) && selectedOptionsParams) {
      url += agedDaysParams
    }
    if (isGGI || isLMH) {
      url += selectedCompany
    }
    return (
      <Button
        bsStyle='success'
        type='button'
        href={url}
      >
        <em className='fa fa-download' />
        <Translate value="simplified_excel" />
      </Button>
    );
  }

  renderDetailedExportButton() {
    const { typeRadios } = this.props;
    const {selectedOptions} = this.state;
    let selectedOptionsParams = selectedOptions.filter(item => item !== 'daysAll').join(',')
    let { Days: date, selectedCompany } = this.props;
    date = moment(date).endOf('day').toISOString();
    date = `PostingDate=${date}`;
    let agedDaysParams = `&aged_days=${selectedOptionsParams || ''}`
    const token = localStorage.getItem('token');
    selectedCompany = `&company_id=${selectedCompany.value}`
    let exportUrl = `${ROOT_URL}v1/ar/report/aged/${typeRadios || 'Active'}/excel/?${date}&Bearer=${token}`;
    if ((isLAP || isAPD) && selectedOptionsParams) {
      exportUrl += agedDaysParams
    }
    let ids = [...this.state.selectedIds];
    if((isLAP || isAPD) && ids.length > 0) {
      exportUrl = exportUrl + `&customer_ids=${ids}`
    }
    if (isGGI || isLMH) {
      exportUrl += selectedCompany
    }
    return (
      <Button
        bsStyle='success'
        className='pull-right'
        href={exportUrl}
      >
        <em className='fa fa-download' />
        <Translate value="detailed_excel" />
      </Button>
    );
  }

  render() {
    const {selectedOptions} = this.state
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>

        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="ar_slashsign_ap" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active='true'>
            <Translate value="ar_aged_report" />
          </Breadcrumb.Item>
        </Breadcrumb>

        <ButtonToolbar>
          {/*
            <Button bsStyle='primary' href={print_url} >
              <em className='fa fa-print' /><Translate value="print" />
              </Button>
          */}
          { this.renderSendExceltButton() }
          { this.renderSimplifiedExportButton() }
          { this.renderPrintStatements() }
          { this.renderDetailedExportButton() }
        </ButtonToolbar>
        {this.renderIFrame()}
        <Grid id='customer-statement'>
          {/* <h1><Translate value="ar_aged_report" /></h1> */}
          {/* Date Range Pickers */}

            <Col xs={ 12 }>
              <Panel id='date-range-picker' className='form-horizontal'>
                <Row>
                    <Col xs={ 2 }>
                      <h3 className="text-right text-nowrap"><Translate value="statement_date" /><span classNames="colon">:</span></h3>
                    </Col>
                    <Col xs={ 10 }>
                      <div id="statusFilterRadios">
                        <ButtonToolbar className='radio-filter-buttons'>
                          <Button bsStyle='primary'>
                            <Field name='Days' placeholder={'Date'} component={DatePicker} />
                          </Button>
                          {/* <Button
                            bsStyle='primary'
                            className='search-btn'
                            type='submit'
                            onClick={() => { this.fetchCustomerStatementList(); }}
                          >
                            <em className='fa fa-search' />
                          </Button> */}
                        </ButtonToolbar>
                      </div>
                  </Col>
                  <Col xs={ 2 }>
                    <h3 className="text-right text-nowrap"><Translate value="customer_status" /><span classNames="colon">:</span></h3>
                  </Col>
                  <Col xs={ 10 }>
                    <div id="statusFilterRadios">
                      <Field name='typeRadios' component={renderCustomerTypeRadios} />
                    </div>
                  </Col>
                {(isLAP || isAPD) &&
                  <div>
                    <Col xs={ 2 }>
                      <h3 className="text-right text-nowrap"><Translate value="aged_days" /><span classNames="colon">:</span></h3>
                    </Col>
                    <Col xs={ 10 }>
                      <div id="agedDaysFilterRadios">
                      <div className='long-radio-filter-buttons'>
                        <Button bsStyle={this.state.selectedOptions.includes('daysAll') ? 'success':'primary'}>
                          <div className='radio'>
                            <label for='days-all-radio-filter'>
                              <input id='days-all-radio-filter' type='radio' name='agedDaysFilterRadios' checked={this.state.selectedOptions.includes('daysAll')} onChange={() => { this.handleButtonClick('daysAll') }} />
                              <Translate value="days_all" />
                            </label>
                          </div>
                        </Button>
                        <Button bsStyle={this.state.selectedOptions.includes('30') ? 'success':'primary'} style={{marginLeft: 6}}>
                          <div className='radio'>
                            <label for='days-0-30-radio-filter'>
                              <input id='days-0-30-radio-filter' type='radio' name='agedDaysFilterRadios' checked={this.state.selectedOptions.includes('30')} onChange={() => { this.handleButtonClick('30') }} />
                              <Translate value="0-30" />
                            </label>
                          </div>
                        </Button>
                        <Button bsStyle={this.state.selectedOptions.includes('60') ? 'success':'primary'} style={{marginLeft: 6}}>
                          <div className='radio'>
                            <label for='days-31-60-radio-filter'>
                              <input id='days-31-60-radio-filter' type='radio' name='agedDaysFilterRadios2' checked={this.state.selectedOptions.includes('60')} onChange={() => { this.handleButtonClick('60') }} />
                              <Translate value="31-60" />
                            </label>
                          </div>
                        </Button>
                        <Button  bsStyle={this.state.selectedOptions.includes('90') ? 'success':'primary'} style={{marginLeft: 6}}>
                          <div className='radio'>
                            <label for='days-61-90-radio-filter'>
                              <input id='days-61-90-radio-filter' type='radio' name='agedDaysFilterRadios3' checked={this.state.selectedOptions.includes('90')} onChange={() => { this.handleButtonClick('90') }} />
                              <Translate value="61-90" />
                            </label>
                          </div>
                        </Button>
                        <Button bsStyle={this.state.selectedOptions.includes('91') ? 'success':'primary'} style={{marginLeft: 6}}>
                          <div className='radio'>
                            <label for='days-90-radio-filter'>
                              <input id='days-90-radio-filter' type='radio' name='agedDaysFilterRadios4' checked={this.state.selectedOptions.includes('91')} onChange={() => { this.handleButtonClick('91') }} />
                              <Translate value="90+" />
                            </label>
                          </div>
                        </Button>
                      </div>
                      </div>
                    </Col>
                  </div>
                }
                </Row>
              </Panel>
              <Row>
                <Col xs={ 12 }>
                  <Panel className="position-relative mb0" id="table-height-fix">
                    {/* Render Inventory Table  */}
                    {this.renderTable() }
                  </Panel>
                </Col>
                <Col xs={ 12 }>
                  <Panel className="position-relative mb0">
                    {/* <Col xs={ 2 }> Commented 11/17/17 branch: feature/ARAP
                      <label className='col-xs-6'><Translate value="current" /></label>
                      <Col xs={ 5 }>
                        <Field name='current' component={DisabledInputField} placeholder={this.state.current}/>
                      </Col>
                    </Col> */}
                  {
                    !isCT && (!(isLAP || isAPD) || (isLAP || isAPD) && (selectedOptions.includes('30') || selectedOptions.includes('daysAll'))) &&
                    <Col xs={2}>
                      <label className='col-xs-6 text-nowrap'><Translate value="00_dashsign_30_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={7}>
                        <Field name='amount00_30' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount00_30)}` || 0} />
                      </Col>
                    </Col>
                  }
                  {
                    isCT &&
                    <div>
                      <Col xs={2}>
                        <label className='col-xs-6 text-nowrap'><Translate value="00_dashsign_07_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                        <Col xs={7}>
                          <Field name='amount00_07' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount00_07)}` || 0} />
                        </Col>
                      </Col>
                      <Col xs={2}>
                        <label className='col-xs-6 text-nowrap'><Translate value="08_dashsign_30_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                        <Col xs={7}>
                          <Field name='amount08_30' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount08_30)}` || 0} />
                        </Col>
                      </Col>
                    </div>
                  }
                  {((isLAP || isAPD) && (selectedOptions.includes('60') || selectedOptions.includes('daysAll')) || !(isLAP || isAPD)) &&
                    <Col xs={ 2 }>
                      <label className='col-xs-6 text-nowrap'><Translate value="31_dashsign_60_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 7 }>
                        <Field name='amount31_60' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount31_60)}` || 0}/>
                      </Col>
                    </Col>
                  }
                  {((isLAP || isAPD) && (selectedOptions.includes('90') || selectedOptions.includes('daysAll')) || !(isLAP || isAPD)) &&
                    <Col xs={ 2 }>
                      <label className='col-xs-6 text-nowrap'><Translate value="61_dashsign_90_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 7 }>
                        <Field name='amount61_90' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount61_90)}` || 0}/>
                      </Col>
                    </Col>
                  }
                  {((isLAP || isAPD) && (selectedOptions.includes('91') || selectedOptions.includes('daysAll')) || !(isLAP || isAPD)) &&
                    <Col xs={ 2 }>
                      <label className='col-xs-6 text-nowrap'><Translate value="91_plussign_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 7 }>
                        <Field name='amount_91' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount_91)}` || 0}/>
                      </Col>
                    </Col>
                  }
                    <Col xs={ 2 }>
                      <label className='col-xs-6 text-nowrap'><Translate value="grand_total" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 7 }>
                        <Field name='grand_amount' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.grand_amount)}` || 0}/>
                      </Col>
                    </Col>
                  </Panel>
                </Col>
              </Row>
            </Col>


        </Grid>
        <EmailContentModal
          visible={this.state.emailContentModalVisibility}
          subject={this.state.emailSubjectTemplate}
          content={this.state.emailContentTemplate}
          onConfirm={(subject, content, email, phone, sendEmail, source)=>{
            let ids = [...this.state.selectedIds];
            if(ids.length == 0) {
              return
            }
            this.handleEmailContentConfirm(subject, content, sendEmail, ids)
          }}
          onClose={this.handleEmailContentClose}
          selectedRows={this.state.selectedRows}
          source={"AR"}
        />
      </ContentWrapper>
      //---------------
      // End HTML: Purchase Order List
      //---------------

    )
  }
}


export default CustomerStatementMain;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/customerStatementMain.jsx